//REACT
import * as React from "react";
import config from "../../configuration/config";
//MATERIAL UI COMPONENTS
import {
  withTheme,
  withStyles,
  Dialog,
  Button,
  Typography,
  TextField,
  InputAdornment,
  List,
  ListItem,
  Divider,
  CircularProgress
} from "@material-ui/core";
import {
  Search,
  Close,
  LocationOn,
} from "@material-ui/icons";
import PropTypes from "prop-types";
//STYLE
import "./regStyles.css";
//COMPONENTS
import globalContext from "../../context/globalContext";

//HELPERS
import { isAlpha } from "validator";
import { isPointWithinRadius } from "geolib";

//MAPBOX
// import ReactMapboxGl from "react-mapbox-gl";
const mbxGeocoding = require("@mapbox/mapbox-sdk/services/geocoding");
const geocodingClient = mbxGeocoding({ accessToken: config.mapbox.key });
// const Map = ReactMapboxGl({
//   accessToken: config.mapbox.key
// });

class NewUserDeliveryLocationDialog extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      mapboxSelectedLocation: null,
      searchCustomerLocationInput: "",
      suggestionList: null,
      address2: "",
      creatingUserLocation: false
    };
  }

  handleChangeId = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSearchMapBoxChange = async event => {
    this.setState({ [event.target.id]: event.target.value });
    await geocodingClient
      .forwardGeocode({
        query: event.target.value,
        countries: ["US"],
        limit: 5
      })
      .send()
      .then(response => {
        let displayLocations = [];
        for (let i in response.body.features) {
          let location = response.body.features[i];
          let formattedLocation = {};
          let customerLocation = {};
          if (location.place_type.includes("address")) {
            let splitAddressArray = location.place_name.split(",");
            formattedLocation.address1 = splitAddressArray[0];
            formattedLocation.city = splitAddressArray[1];
            formattedLocation.state = abbrRegion(
              splitAddressArray[2].slice(1, -6),
              "TO_ABBREVIATED"
            );
            formattedLocation.zip = splitAddressArray[2].substr(-5);
            location.displayAddress = formattedLocation;
            customerLocation = { ...location };
            displayLocations.push(customerLocation);
          }
        }
        this.setState({ suggestionList: displayLocations });
      });

    // window.scrollTo(0, document.body.scrollHeight)
  };

  selectUserLocation = location => {
    const { shoppingCart } = this.context.global.data;
    let customerLocation = {};
    let formattedLocation = {};
    if (location.place_name) {
      let splitAddressArray = location.place_name.split(",");
      formattedLocation.address1 = splitAddressArray[0];
      formattedLocation.city = splitAddressArray[1];
      formattedLocation.state = abbrRegion(
        splitAddressArray[2].slice(1, -6),
        "TO_ABBREVIATED"
      );
      formattedLocation.zip = splitAddressArray[2].substr(-5);
      customerLocation = { ...location, ...formattedLocation };
      delete customerLocation.type;
    }

    customerLocation.mapboxId = location.id;

    if (location.latitude && location.longitude) {
      customerLocation.longitude = location.longitude;
      customerLocation.latitude = location.latitude;
    } else if (location.center && location.center.length > 1) {
      customerLocation.longitude = location.center[0];
      customerLocation.latitude = location.center[1];
    } else if (
      (!location.center || location.center.length < 1) &&
      location.geometry &&
      location.geometry.center
    ) {
      customerLocation.longitude = location.geometry.center[0];
      customerLocation.latitude = location.geometry.center[1];
    } else {
      return console.log("NO COORDINATE", location);
    }

    if (
      customerLocation &&
      shoppingCart &&
      shoppingCart.popUpLocationInstance.fulfillmentType === "DELIVERY" &&
      !this.props.noCheckShoppingCart
    ) {
      let test = isPointWithinRadius(
        {
          latitude: customerLocation.latitude,
          longitude: customerLocation.longitude
        },
        {
          latitude: shoppingCart.deliveryLocation.latitude,
          longitude: shoppingCart.deliveryLocation.longitude
        },
        shoppingCart.popUpLocationInstance.deliveryRadiusMiles * 1609.34
      );
      if (!test) {
        this.context.global.openErrorSnackbar(
          "This location is not in the delivery radius for this Hotspot."
        );
      } else {
        this.setState({ mapboxSelectedLocation: customerLocation });
      }
    } else {
      this.setState({ mapboxSelectedLocation: customerLocation });
    }
  };

  createUserLocation = async () => {
    const { shoppingCart } = this.context.global.data;
    let { mapboxSelectedLocation, address2 } = this.state;
    mapboxSelectedLocation.address2 = address2;
    this.setState({ creatingUserLocation: true });
    let location = await this.context.global.createUserLocation(
      mapboxSelectedLocation
    );
    if (
      shoppingCart &&
      shoppingCart.popUpLocationInstance.fulfillmentType === "DELIVERY" &&
      !this.props.noCheckShoppingCart
    ) {
      this.context.global.updateDeliveryLocation(location);
    }
    await this.context.global.getUserByUuid();
    this.setState({
      mapboxSelectedLocation: null,
      searchCustomerLocationInput: "",
      address2: "",
      suggestionList: null,
      creatingUserLocation: false
    });
    this.props.updateFunction();
    this.context.global.handleCloseNewUserDeliveryLocationDialog();
  };

  closeDialog = () => {
    this.setState({
      mapboxSelectedLocation: null,
      searchCustomerLocationInput: "",
      address2: "",
      suggestionList: null,
      creatingUserLocation: false
    });
    this.context.global.handleCloseNewUserDeliveryLocationDialog();
  };

  render() {
    const { classes, theme } = this.props;
    const { newUserDeliveryLocationDialog } = this.context.global.data;
    const {
      mapboxSelectedLocation,
      searchCustomerLocationInput,
      suggestionList,
      address2,
      creatingUserLocation
    } = this.state;

    return (
      <>
        <Dialog
          fullWidth
          open={newUserDeliveryLocationDialog}
          // onClose={() => this.closeDialog()}
          maxWidth={false}
          style={{ zIndex: 90002 }}
        >
          <div
            className="notInDeliveryRadiusContainer_top"
            style={{ backgroundColor: theme.palette.primary.main }}
          >
            <Close
              style={{
                // display: "flex",
                // position: 'absolute',
                color: "white"
                // backgroundColor: "white",
                // boxShadow: "1px 1px 1px 1px #999",
                // borderRadius: 20,
                // alignSelf: "flex-end"
                // right: -50
              }}
              onClick={() => this.closeDialog()}
            />
          </div>
          <div className="findHotSpotZip_mapboxNewLocationDialog_outer">
            {!mapboxSelectedLocation ? (
              <>
                <Typography>What address?</Typography>

                <TextField
                  multiline
                  autoFocus
                  fullWidth
                  id="searchCustomerLocationInput"
                  // label="delivery address"
                  value={searchCustomerLocationInput}
                  onChange={this.handleSearchMapBoxChange.bind(this)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment
                        onClick={() =>
                          this.setState({
                            searchCustomerLocationInput: "",
                            suggestionList: null
                          })
                        }
                        position="end"
                      >
                        <Close />
                      </InputAdornment>
                    )
                  }}
                />

                {suggestionList ? (
                  <>
                    <List>
                      {suggestionList.map(loc => {
                        return (
                          <>
                            <ListItem
                              className={classes.userLocationListItem}
                              button
                              onClick={async () => {
                                await this.selectUserLocation(loc);
                                // await this.setState({
                                //   mapboxNewLocationDialogOpen: false
                                // })
                              }}
                            >
                              <LocationOn
                                style={{
                                  color: theme.palette.primary.main,
                                  paddingRight: 5
                                }}
                              />
                              <Typography variant={"body2"}>
                                {loc.displayAddress.address1}
                                <Typography variant={"caption"}>
                                  {loc.displayAddress.city} {" , "}{" "}
                                  {loc.displayAddress.state}
                                </Typography>
                              </Typography>
                            </ListItem>
                            <Divider />
                          </>
                        );
                      })}
                    </List>
                  </>
                ) : null}
              </>
            ) : null}
            {mapboxSelectedLocation ? (
              <div className="availability_customerNewLocationDialog_inner">
                <div className="availability_customerNewLocationDialog_inner_top">
                  <Typography>Selected Address</Typography>

                  <div className="dialogRow">
                    <div className="dialogRowContainer">
                      <div className="dialogRowLeft">
                        <LocationOn
                          style={{
                            color: theme.palette.primary.main
                          }}
                        />
                      </div>
                      <div className="dialogRowRight">
                        {/* <div className={s.dialogHeader}>{userLocation && userLocation.place_name ? userLocation.place_name : (userLocation.name - userLocation.address1, userLocation.zip)}</div> */}
                        <div className="dialogSubHeader">
                          <div>{mapboxSelectedLocation.address1}</div>
                          <div>{mapboxSelectedLocation.address2}</div>
                          <div>
                            {mapboxSelectedLocation.city}{" "}
                            {mapboxSelectedLocation.state}{" "}
                            {mapboxSelectedLocation.zip}
                          </div>
                        </div>
                      </div>
                      <p
                        onClick={() =>
                          this.setState({ mapboxSelectedLocation: null })
                        }
                        style={{
                          textDecoration: "underline",
                          textAlign: "right",
                          fontFamily: "Montserrat",
                          fontSize: 12
                        }}
                      >
                        Change
                      </p>
                    </div>
                  </div>

                  <div
                    className="dialogSubHeader"
                    style={{ textAlign: "center" }}
                  >
                    Is there anything your driver should know about this
                    address? Apartment number, gate or door code?
                  </div>

                  <TextField
                    multiline
                    // autoFocus
                    fullWidth
                    id="address2"
                    helperText="(e.g. APT 123, Unit A, Passcode 1234)"
                    value={address2}
                    onChange={this.handleChangeId.bind(this)}
                  />
                </div>

                <Button
                  disabled={(() => {
                    if (creatingUserLocation) {
                      return true;
                    }
                  })()}
                  style={{ width: "100%", marginTop: 10 }}
                  onClick={async () => {
                    await this.createUserLocation();
                  }}
                >
                  {creatingUserLocation ? (
                    <CircularProgress style={{ height: 25, width: 25 }} />
                  ) : (
                    "Update Delivery Location"
                  )}
                </Button>
              </div>
            ) : null}
          </div>
        </Dialog>
      </>
    );
  }
}

NewUserDeliveryLocationDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = theme => ({});

export default withTheme()(withStyles(styles)(NewUserDeliveryLocationDialog));

function abbrRegion(input, to) {
  var states = [
    ["Alabama", "AL"],
    ["Alaska", "AK"],
    ["American Samoa", "AS"],
    ["Arizona", "AZ"],
    ["Arkansas", "AR"],
    ["Armed Forces Americas", "AA"],
    ["Armed Forces Europe", "AE"],
    ["Armed Forces Pacific", "AP"],
    ["California", "CA"],
    ["Colorado", "CO"],
    ["Connecticut", "CT"],
    ["Delaware", "DE"],
    ["District Of Columbia", "DC"],
    ["Florida", "FL"],
    ["Georgia", "GA"],
    ["Guam", "GU"],
    ["Hawaii", "HI"],
    ["Idaho", "ID"],
    ["Illinois", "IL"],
    ["Indiana", "IN"],
    ["Iowa", "IA"],
    ["Kansas", "KS"],
    ["Kentucky", "KY"],
    ["Louisiana", "LA"],
    ["Maine", "ME"],
    ["Marshall Islands", "MH"],
    ["Maryland", "MD"],
    ["Massachusetts", "MA"],
    ["Michigan", "MI"],
    ["Minnesota", "MN"],
    ["Mississippi", "MS"],
    ["Missouri", "MO"],
    ["Montana", "MT"],
    ["Nebraska", "NE"],
    ["Nevada", "NV"],
    ["New Hampshire", "NH"],
    ["New Jersey", "NJ"],
    ["New Mexico", "NM"],
    ["New York", "NY"],
    ["North Carolina", "NC"],
    ["North Dakota", "ND"],
    ["Northern Mariana Islands", "NP"],
    ["Ohio", "OH"],
    ["Oklahoma", "OK"],
    ["Oregon", "OR"],
    ["Pennsylvania", "PA"],
    ["Puerto Rico", "PR"],
    ["Rhode Island", "RI"],
    ["South Carolina", "SC"],
    ["South Dakota", "SD"],
    ["Tennessee", "TN"],
    ["Texas", "TX"],
    ["US Virgin Islands", "VI"],
    ["Utah", "UT"],
    ["Vermont", "VT"],
    ["Virginia", "VA"],
    ["Washington", "WA"],
    ["West Virginia", "WV"],
    ["Wisconsin", "WI"],
    ["Wyoming", "WY"]
  ];

  // So happy that Canada and the US have distinct abbreviations
  var provinces = [
    ["Alberta", "AB"],
    ["British Columbia", "BC"],
    ["Manitoba", "MB"],
    ["New Brunswick", "NB"],
    ["Newfoundland", "NF"],
    ["Northwest Territory", "NT"],
    ["Nova Scotia", "NS"],
    ["Nunavut", "NU"],
    ["Ontario", "ON"],
    ["Prince Edward Island", "PE"],
    ["Quebec", "QC"],
    ["Saskatchewan", "SK"],
    ["Yukon", "YT"]
  ];

  var regions = states.concat(provinces);

  var i; // Reusable loop variable
  if (to === "TO_ABBREVIATED") {
    if (isAlpha && input.length === 2) {
      return input;
    } else {
      input = input.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      for (i = 0; i < regions.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (regions[i][0] == input) {
          return regions[i][1];
        }
      }
    }
  } else if (to === "TO_NAME") {
    input = input.toUpperCase();
    for (i = 0; i < regions.length; i++) {
      // eslint-disable-next-line eqeqeq
      if (regions[i][1] == input) {
        return regions[i][0];
      }
    }
  }
}
